"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutGrid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
exports.LayoutGrid = function (_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement(core_1.Grid, tslib_1.__assign({}, props), children));
};
